import { NJModal, NJModalContent, NJButton } from '@engie-group/fluid-design-system-react';


function ModalDeleteJobAd({ isOpen, id, handleDelete, handleCancel }) {

    return (
        <NJModal
            id="modalDelete"
            isOpen={isOpen}
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="bold"
                            variant="secondary"
                            label="Cancel"
                            onClick={handleCancel}
                        />    
                         <NJButton
                            label="Delete"
                            onClick={() => { handleDelete(id) }}
                            variant="destructive" 
                             icon="delete_outline"
                            />
                    </>
                }
                icon="delete_outline"
                id="modalDelete"
                onClose={handleCancel}
                title="Delete of the Job Ad"
            >
                <div>
                    Are you sure of yourself? This action is irreversible.
                </div>
            </NJModalContent>
        </NJModal>
    )
}

export default ModalDeleteJobAd;
